"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.top = exports.right = exports.left = exports.bottom = exports.all = void 0;
require("./padding.css");
/**
 * DO NOT MODIFY
 * Generated from scripts/codegen/main.ts
 */

const all = {
  0: "cds-0-_1t4ck38",
  1: "cds-1-_7dfei4",
  2: "cds-2-_fbgb57",
  3: "cds-3-_64wlqa",
  4: "cds-4-_c5vcwt",
  5: "cds-5-_38cxb9",
  6: "cds-6-_wp4z0x",
  7: "cds-7-_cd8zen",
  8: "cds-8-_1mmgrgj",
  9: "cds-9-_y3e495",
  10: "cds-10-_13z95om",
  0.5: "cds-0_5-_1mrjmpn",
  1.5: "cds-1_5-_6zp90p"
};
exports.all = all;
const top = {
  0: "cds-0-_fibjmj",
  1: "cds-1-_1xqs9y8",
  2: "cds-2-_115h1mf",
  3: "cds-3-_1ixgcz3",
  4: "cds-4-_1w9a5m",
  5: "cds-5-_dyupck",
  6: "cds-6-_x0ms2s",
  7: "cds-7-_1t2qdmw",
  8: "cds-8-_c4xx9n",
  9: "cds-9-_t4vl43",
  10: "cds-10-_1oczfiq",
  0.5: "cds-0_5-_1oy8l1i",
  1.5: "cds-1_5-_18ml2at"
};
exports.top = top;
const bottom = {
  0: "cds-0-_vhy4ik",
  1: "cds-1-_9w3lns",
  2: "cds-2-_1qjdqpv",
  3: "cds-3-_1mvq9l2",
  4: "cds-4-_q93lq3",
  5: "cds-5-_g0seea",
  6: "cds-6-_k114rn",
  7: "cds-7-_33g99c",
  8: "cds-8-_1ij8b3o",
  9: "cds-9-_58kcht",
  10: "cds-10-_1jhyfz6",
  0.5: "cds-0_5-_uaer6w",
  1.5: "cds-1_5-_rro7jr"
};
exports.bottom = bottom;
const left = {
  0: "cds-0-_15toyjv",
  1: "cds-1-_aw0v8j",
  2: "cds-2-_h5hy70",
  3: "cds-3-_1ol1258",
  4: "cds-4-_1arbnhr",
  5: "cds-5-_1fh7zw6",
  6: "cds-6-_1iifjn6",
  7: "cds-7-_1wg6ttf",
  8: "cds-8-_sl1i61",
  9: "cds-9-_x4cyln",
  10: "cds-10-_qem5ui",
  0.5: "cds-0_5-_1gzxkm",
  1.5: "cds-1_5-_1lj9szt"
};
exports.left = left;
const right = {
  0: "cds-0-_1007wyr",
  1: "cds-1-_7ojgr9",
  2: "cds-2-_hu3zq5",
  3: "cds-3-_1ti0n00",
  4: "cds-4-_hd2z08",
  5: "cds-5-_1yjsi5b",
  6: "cds-6-_1ts70zl",
  7: "cds-7-_13v6b6w",
  8: "cds-8-_rts7lp",
  9: "cds-9-_1saw5bv",
  10: "cds-10-_16efk9b",
  0.5: "cds-0_5-_161g670",
  1.5: "cds-1_5-_v1nhhc"
};
exports.right = right;